import {ApiStatus} from '../../models';

export enum EXECUTION_STATUS {
  SUCCESS = 'success',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export const FINISH_STATUS = [ApiStatus.LOADED, ApiStatus.FAILED];
